import SharedAsset from '@zenbusiness/zui/SharedAsset';
import { styled, useTheme } from '@zenbusiness/zui/styles';
import PropTypes from 'prop-types';

import { TRANSACTION_DIRECTION } from './constants';

// Styled component for icon border
const IconBorderStyled = styled('div')(({ theme }) => ({
  border: `1px solid ${theme.palette.border.main}`,
  backgroundColor: theme.palette.background.grey.main,
  borderRadius: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 1 auto',
  overflowY: 'auto',
  width: '32px',
  height: '32px',
  [theme.breakpoints.up('md')]: {
    width: '40px',
    height: '40px'
  }
}));

// Component to render the direction type icon
const DirectionTypeIcon = ({ direction, isActive, isPayment = false }) => {
  const theme = useTheme();

  // Determine active style based on `isActive`
  const activeStyle = isActive
    ? { backgroundColor: theme.palette.fixed.black, color: theme.palette.background.grey.main }
    : {};

  // Determine icon color and source based on props
  const iconColor = isActive ? 'rgb:FFFFFF' : '';
  const iconSrc = (() => {
    const isDebit = direction === TRANSACTION_DIRECTION.DEBIT;
    const arrowDirection =
      (isDebit && isPayment) || (!isDebit && !isPayment) ? 'bottom-right' : 'top-right';
    return `/s2/icon/arrow-${arrowDirection}-fill.svg`;
  })();

  // Conditional rendering of the icon
  const icon = iconSrc ? (
    <SharedAsset
      alt=""
      color={iconColor}
      src={iconSrc}
    />
  ) : null;

  return (
    <IconBorderStyled
      aria-label="icon-wrapper"
      sx={activeStyle}
    >
      {icon}
    </IconBorderStyled>
  );
};

// PropTypes for validation
DirectionTypeIcon.propTypes = {
  direction: PropTypes.string.isRequired,
  isActive: PropTypes.bool,
  isPayment: PropTypes.bool
};

export default DirectionTypeIcon;
